export default __webpack_public_path__ + "640e0dda91bd706df2bc930551f73274.gif";